<div class="adf-viewer__unknown-format-view">
    <div>
        <mat-icon class="icon">error</mat-icon>
        <div class="adf-viewer__unknown-label">{{ 'ADF_VIEWER.UNKNOWN_FORMAT' | translate }}</div>
    </div>
</div>
